import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * A component that scrolls the window to the top whenever the route changes.
 * This is a common requirement for single-page applications using react-router.
 */
const ScrollToTop = () => {
  // Extracts pathname property from location object
  const { pathname } = useLocation();

  // This effect runs whenever the pathname changes
  useEffect(() => {
    // `window.scrollTo(0, 0)` scrolls the window to the top-left corner.
    window.scrollTo(0, 0);
  }, [pathname]); // The effect dependency array with `pathname` ensures it runs only on route change

  // This component does not render any UI
  return null;
};

export default ScrollToTop;